<div class="content-container billing" *ngIf="!experimentInfo">
	<section class="data-table">
		<header class="data-table__header">
			<h2 class="page-heading">
				<svg width="37" height="37" viewBox="0 0 37 37">
					<path class="svg-stroke" stroke-linecap="round" d="M20.758 17.371h2.258M20.758 12.855h2.258M20.758 8.339h2.258M6.08 17.371h10.162M6.08 12.855h10.162M6.08 8.339h10.162" />
					<path class="svg-stroke" stroke-linecap="square" d="M31.484 1H4.952A3.952 3.952 0 0 0 1 4.952V36l3.387-2.258L7.774 36l3.387-2.258L14.548 36l3.387-2.258L21.323 36l3.387-2.258L28.097 36V4.952A3.963 3.963 0 0 1 32.048 1 3.963 3.963 0 0 1 36 4.952h-3.387" />
					<path class="svg-stroke" stroke-linecap="round" d="M6.08 26.403h10.162M20.194 28.097a2.005 2.005 0 0 0 1.693 1.129h1.13c.93 0 1.693-.762 1.693-1.694 0-.931-.762-1.693-1.694-1.693h-1.129a1.699 1.699 0 0 1-1.693-1.694c0-.931.762-1.693 1.693-1.693h1.13s1.128 0 1.693 1.129M22.452 21.323v1.129M22.452 29.226v1.129" />
				</svg>
				<ng-container i18n="@@billing">Billing</ng-container>
			</h2><!-- data-table__heading -->
		</header><!-- end billing-header -->

		<div class="data-table__wrap">
			<header class="data-table__controls">
				<select nice-select (change)="switchTab($event.target.value)" class="select-link" id="tab-links-select">
					<option [value]="'subscription-history'" i18n="@@billing.teem_subscription">Teem Subscription</option>
					<!-- <option [value]="'invoice-subscription-history'" i18n="@@billing.online_payment_subscription">Online payment subscriptions</option> -->
					<option [value]="'billing-history'" i18n="@@billing.all_invoices">All Invoices</option>
				</select>

				<ul class="nav nav-pills" id="pills-tab" role="tablist">
					<li class="nav-item">
						<a class="nav-link active" id="pills-subscription-pill" data-toggle="pill" href="javascript:void(0);" role="tab" aria-controls="pills-subscription" aria-selected="true" (click)="switchTab('subscription-history')" [class.active]="activeTab == 'subscription-history'">
							<ng-container i18n="@@billing.teem_subscription">Teem Subscription</ng-container>
						</a>
					</li>
					<!-- <li class="nav-item">
						<a class="nav-link active" id="pills-subscription-pill" data-toggle="pill" href="javascript:void(0);" role="tab" aria-controls="pills-subscription" aria-selected="true" (click)="switchTab('invoice-subscription-history')" [class.active]="activeTab == 'invoice-subscription-history'">
							<ng-container i18n="@@billing.online_payment_subscription">Online payment subscriptions</ng-container>
						</a>
					</li> -->
					<li class="nav-item">
						<a class="nav-link" id="pills-billing-history-pill" data-toggle="pill" href="javascript:void(0);" role="tab" aria-controls="pills-billing-history" aria-selected="false" (click)="switchTab('billing-history')" [class.active]="activeTab == 'billing-history'">
							<ng-container i18n="@@billing.all_invoices">All Invoices</ng-container>
						</a>
					</li>
				</ul>
				<!-- <div>
					<a [routerLink]="['/setting']" class="tu-btn transparent"  i18n="@@common.back">Back</a>
				</div> -->
			</header><!-- end header -->
			
			<div class="tab-content data-table__tab-content" id="pills-tabContent">
				<div class="tab-pane fade show active" id="pills-subscription" role="tabpanel" aria-labelledby="pills-subscription-tab" [ngClass]="{'active show': activeTab == 'subscription-history'}">
					<subscription-history style="width: 100%;"></subscription-history>
				</div>

				<div class="tab-pane fade show active" id="pills-subscription" role="tabpanel" aria-labelledby="pills-subscription-tab" [ngClass]="{'active show': activeTab == 'invoice-subscription-history'}">
					<invoice-subscription-history></invoice-subscription-history>
				</div>

				<!-- <div class="tab-pane fade" id="pills-billing-history" role="tabpanel" aria-labelledby="pills-billing-history-tab" [ngClass]="{'active show': activeTab == 'billing-history'}">
					<teemapp-table [name]="'billing-history'" [tableSchema]="historyTable" [selectable]="false" #historyTableRef></teemapp-table>
				</div>

				<div class="tab-pane fade" id="pills-billing-history" role="tabpanel" aria-labelledby="pills-billing-history-tab" [ngClass]="{'active show': activeTab == 'invoice-transaction-history'}">
					<teemapp-table [name]="'billing-history'" [tableSchema]="invoiceTransactionHistoryTable" [selectable]="false" #invoiceTransactionHistoryTableRef></teemapp-table>
				</div> -->
			</div>
		</div><!-- end data-table__wrap -->
	</section><!-- end data-table -->
</div>
<!-- <div class="content-container plans" *ngIf="userInfo?.billing_experimente_data && !isEmpty(userInfo.billing_experimente_data)"> -->


<div class="content-container plans" *ngIf="experimentInfo">
	<section class="data-table">
		<header class="data-table__header">
			<h2 class="page-heading">
				<svg width="37" height="37" viewBox="0 0 37 37">
					<path class="svg-stroke" stroke-linecap="round" d="M20.758 17.371h2.258M20.758 12.855h2.258M20.758 8.339h2.258M6.08 17.371h10.162M6.08 12.855h10.162M6.08 8.339h10.162" />
					<path class="svg-stroke" stroke-linecap="square" d="M31.484 1H4.952A3.952 3.952 0 0 0 1 4.952V36l3.387-2.258L7.774 36l3.387-2.258L14.548 36l3.387-2.258L21.323 36l3.387-2.258L28.097 36V4.952A3.963 3.963 0 0 1 32.048 1 3.963 3.963 0 0 1 36 4.952h-3.387" />
					<path class="svg-stroke" stroke-linecap="round" d="M6.08 26.403h10.162M20.194 28.097a2.005 2.005 0 0 0 1.693 1.129h1.13c.93 0 1.693-.762 1.693-1.694 0-.931-.762-1.693-1.694-1.693h-1.129a1.699 1.699 0 0 1-1.693-1.694c0-.931.762-1.693 1.693-1.693h1.13s1.128 0 1.693 1.129M22.452 21.323v1.129M22.452 29.226v1.129" />
				</svg>
				<ng-container i18n="@@setting.plan">Plans</ng-container>
			</h2><!-- data-table__heading -->
		</header><!-- end plans-header -->

		<div class="account-setting white-bg">
			<div class="account-setting__content">
				<div class="account-setting__plans">
					<!-- <manage-plan id="targetScroll" [plans]="plans" [userDetails]="userInfo" (onPlanChange)="onPlanChange()"></manage-plan> -->
					<subscription-plan class="w-100"></subscription-plan>
				</div>
			</div>
		</div>
	</section>
</div>
<!-- end content-container -->

<div class="content-container" *ngIf="activeTab != 'view-billing-subscription' && activeTab != 'view-billing-Transaction' && (activeTab == 'billing-history' ||  'invoice-transaction-history')">
	<section class="data-table invoice all-lists inv-billing">
		<div class="data-table__wrap" *ngIf="activeTab != 'view-billing-subscription' && activeTab != 'view-billing-Transaction' && (activeTab == 'billing-history' ||  'invoice-transaction-history')">
			<div class="tab-content data-table__tab-content" id="pills-tabContent">
				<div *ngIf="activeTab == 'billing-history'" class="tab-pane fade" id="pills-billing-history" role="tabpanel" aria-labelledby="pills-billing-history-tab" [ngClass]="{'active show': activeTab == 'billing-history'}">
					<teemapp-table [name]="'billing-history'" [tableSchema]="historyTable" [selectable]="false" (onLoad)="onLoadBillingHistory($event)" #historyTableRef></teemapp-table>
        </div>

				<div *ngIf="activeTab == 'invoice-transaction-history'" class="tab-pane fade" id="invoice-transaction-history" role="tabpanel" aria-labelledby="pills-billing-history-tab" [ngClass]="{'active show': activeTab == 'invoice-transaction-history'}">
					<teemapp-table [name]="'invoice-transaction-history'" [tableSchema]="invoiceTransactionHistoryTable" [selectable]="false" #invoiceTransactionHistoryTableRef></teemapp-table>
				</div>
			</div>
		</div>
	</section>
</div>
